import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './stores'

// REM 适配 - 必须在样式之前引入
import './utils/rem'

// 全局样式 - 覆盖浏览器默认样式
import './styles/style.scss'

// Vant Toast
import { showToast } from 'vant'
import 'vant/es/toast/style'

const app = createApp(App)

app.use(pinia)
app.use(router)

// 全局挂载 Toast 方法
app.config.globalProperties.$showToast = showToast

app.mount('#app')
